import { SVGProps } from "react";

export const AiPowerIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M8 4.75A3.25 3.25 0 0 0 4.75 8v8A3.25 3.25 0 0 0 8 19.25h8A3.25 3.25 0 0 0 19.25 16V8A3.25 3.25 0 0 0 16 4.75zm.25-1.5h1.5V2a.75.75 0 0 1 1.5 0v1.25h1.5V2a.75.75 0 0 1 1.5 0v1.25h1.5V2a.75.75 0 0 1 1.5 0v1.416a4.76 4.76 0 0 1 3.334 3.334H22a.75.75 0 0 1 0 1.5h-1.25v1.5H22a.75.75 0 0 1 0 1.5h-1.25v1.5H22a.75.75 0 0 1 0 1.5h-1.25v1.5H22a.75.75 0 0 1 0 1.5h-1.416a4.76 4.76 0 0 1-3.334 3.334V22a.75.75 0 0 1-1.5 0v-1.25h-1.5V22a.75.75 0 0 1-1.5 0v-1.25h-1.5V22a.75.75 0 0 1-1.5 0v-1.25h-1.5V22a.75.75 0 0 1-1.5 0v-1.416a4.76 4.76 0 0 1-3.334-3.334H2a.75.75 0 0 1 0-1.5h1.25v-1.5H2a.75.75 0 0 1 0-1.5h1.25v-1.5H2a.75.75 0 0 1 0-1.5h1.25v-1.5H2a.75.75 0 0 1 0-1.5h1.416A4.76 4.76 0 0 1 6.75 3.416V2a.75.75 0 0 1 1.5 0zm5.47 4.458a.3.3 0 0 1 .559 0l.805 2.04a.3.3 0 0 0 .168.168l2.04.805a.3.3 0 0 1 0 .558l-2.04.805a.3.3 0 0 0-.168.169l-.805 2.04a.3.3 0 0 1-.558 0l-.805-2.04a.3.3 0 0 0-.169-.17l-2.04-.804a.3.3 0 0 1 0-.558l2.04-.805a.3.3 0 0 0 .17-.169zm-3.941 5a.3.3 0 0 0-.558 0l-.38.964a.3.3 0 0 1-.17.169l-.963.38a.3.3 0 0 0 0 .558l.964.38a.3.3 0 0 1 .169.17l.38.963a.3.3 0 0 0 .558 0l.38-.964a.3.3 0 0 1 .17-.169l.963-.38a.3.3 0 0 0 0-.558l-.964-.38a.3.3 0 0 1-.169-.17z"
        clipRule="evenodd"
        fillOpacity=".9"
        fillRule="evenodd"
      />
    </svg>
  );
};
